import { Box, SxProps } from '@mui/material';
import { FC } from 'react';
import VideoFilePlayer from 'react-player/file';

type Props = {
  url: string;
  width?: string;
  controls?: boolean;
  autoplay?: boolean;
  sx?: SxProps;
};

export const VideoPlayer: FC<Props> = ({ url, width, controls = true, autoplay = true, sx }) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
      sx={{ '& video': { borderRadius: '16px' }, ...sx }}
    >
      <VideoFilePlayer
        url={url}
        config={{
          forceVideo: true
        }}
        playing={autoplay}
        volume={0}
        controls={controls}
        width={width ? width : '100%'}
        height="100%"
      />
    </Box>
  );
};
